







import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import LoginBox from "@/components/LoginBox.vue";
import { auth } from "@/service/auth";
@Component({
  components: {
    Header,
    LoginBox
  }
})
export default class app extends Vue {
  onSubmit() {}
}
